import React from 'react';
import { CheckIcon, MicroscopeIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach Forensic Science with confidence starting today'];
export function FinalCta() {
  return <section className="bg-navy-900 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-74" data-mp="1jbk4psx6m93d">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-75" data-mp="1ed8wtnqg68ns">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-silver-200" data-id="element-76" data-mp="1t2okuvylfzzs">
          <MicroscopeIcon className="h-4 w-4" aria-hidden="true" data-id="element-77" data-mp="1o3lf19ashpqr" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-78" data-mp="222uw0b6tknvs">
          Created by forensic science education specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-79" data-mp="n6w5wvtqbkam" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border border-silver-300/40 bg-navy-800 p-6 text-left shadow-2xl shadow-black/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-80" data-mp="n7yyr9am3wt6">
          <p data-id="element-81" data-mp="x5v7xvjzohon">
            <b className="block text-sm uppercase leading-tight text-white" data-id="element-82" data-mp="122vc20xa3ad4">{productShortName}</b>
            <span className="text-sm text-silver-300" data-id="element-83" data-mp="164gm7eifhajm">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-84" data-mp="1b1ytl0gsrhpi">
            <p className="text-sm text-silver-300" data-id="element-85" data-mp="1ftqeaud9ut7q">
              <span className="mr-2 line-through" data-id="element-86" data-mp="1fv1r1jop3baz">{priceBefore}</span>
              <b className="text-base text-white" data-id="element-87" data-mp="1ksbfaw0clgx8">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-88" data-mp="1pszew62n7632">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-silver-200" data-id="element-89" data-mp="3qu5nu27j5dmg">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-90" data-mp="3lxf8xi7goo2m">
              <CheckIcon className="h-4 w-4 text-silver-300" aria-hidden="true" data-id="element-91" data-mp="3iehemtvbu1m" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}